import { Outlet } from "react-router";

export default function Company() {
  return <Outlet />;
}
